// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tbl_remessas thead {
  background-color: #000 !important;
}

h3 {
  color: #666;
  font-weight: 600;
  font-size: 12pt;
  border: solid 2px #22b7ff;
  padding: 7px 10px;
  border-radius: 5px;
  background-color: rgba(34, 183, 255, 0.1);
  margin-top: 25px;
  text-align: left;
  display: inline-block;
}

.btn-registrar {
  margin-top: 23px;
}

h3 .qtd-item-remessa {
  color: #ffb07e;
}

h3 .alert-remessa-azul {
  color: #22b7ff;
}

.inicio {
  margin: 20px;
}

@media only screen and (max-width: 1350px) {
  #remessas h3 {
    width: 100%;
    text-align: center;
  }
  .pull-right {
    width: 100%;
    float: left !important;
  }
  .pull-right .dropdown {
    width: 57%;
    float: left;
    margin-left: 0;
    margin-right: 1.5%;
    margin-top: 7.5px;
  }
  .pull-right .btn-registrar {
    width: 40%;
    float: left;
    margin-left: 1.5%;
    margin-top: 32px;
  }
}
@media only screen and (max-width: 465px) {
  #remessas h3 {
    width: 100%;
  }
  .pull-right {
    width: 100%;
    float: left !important;
  }
  .pull-right .dropdown {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    margin-top: 7.5px;
  }
  .pull-right .btn-registrar {
    width: 100%;
    margin-top: 5px;
    margin-left: 0;
  }
}
.dropdown {
  margin-left: 7.5px;
  margin-right: 20px;
  margin-bottom: 7.5px;
  float: left;
}

.dropdown-toggle.btn-default {
  transition: 0.5s;
}

.dropdown-toggle.btn-default:hover, .dropdown-toggle.btn-default:focus {
  background-color: #fff;
  border: 1px solid #00f6ff;
  transition: 0.5s;
}

.dropdown.open > .btn {
  box-shadow: none;
}

.dropdown label {
  width: 100%;
  line-height: 17px;
}

.dropdown button {
  border-width: 1px;
  width: 100%;
  background-color: #fff;
  margin-right: 20px;
  text-align: left;
  padding-left: 13px;
  font-size: 13px;
}

.dropdown-menu {
  width: 100%;
}

.dropdown-menu:not(.head-list) > li > a {
  padding: 10px 20px;
  cursor: pointer;
}

.dropdown .dropdown-toggle {
  position: relative;
}

.dropdown .dropdown-toggle span {
  position: absolute;
  right: 10px;
  top: 15px;
}

.container-loading {
  width: 35px;
  height: 35px;
  margin: 0 auto;
}
.container-loading .loading {
  margin: 100px 0 0 0;
}

.error {
  width: 100%;
  font-size: 16px;
  font-weight: 100;
  color: #999999;
  text-align: center;
  display: inline-block;
}
.error:first-child {
  margin-top: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/boletos/remessa/remessa.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAEA;EACI,iCAAA;AADJ;;AAIA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,cCpBO;ADmBX;;AAIA;EACI,YAAA;AADJ;;AAIA;EAEQ;IACI,WAAA;IACA,kBAAA;EAFV;EAME;IACI,WAAA;IACA,sBAAA;EAJN;EAMM;IACI,UAAA;IACA,WAAA;IACA,cAAA;IACA,kBAAA;IACA,iBAAA;EAJV;EAOM;IACI,UAAA;IACA,WAAA;IACA,iBAAA;IACA,gBAAA;EALV;AACF;AASA;EAEQ;IACI,WAAA;EARV;EAYE;IACI,WAAA;IACA,sBAAA;EAVN;EAYM;IACI,WAAA;IACA,cAAA;IACA,eAAA;IACA,iBAAA;EAVV;EAaM;IACI,WAAA;IACA,eAAA;IACA,cAAA;EAXV;AACF;AAeA;EACI,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;AAbJ;;AAgBA;EACI,gBAAA;AAbJ;;AAgBA;EACI,sBC7EI;ED8EJ,yBAAA;EACA,gBAAA;AAbJ;;AAgBA;EACI,gBAAA;AAbJ;;AAgBA;EACI,WAAA;EACA,iBAAA;AAbJ;;AAgBA;EACI,iBAAA;EACA,WAAA;EACA,sBC9FI;ED+FJ,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAbJ;;AAgBA;EACI,WAAA;AAbJ;;AAgBA;EACI,kBAAA;EACA,eAAA;AAbJ;;AAgBA;EACI,kBAAA;AAbJ;;AAgBA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AAbJ;;AAgBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAbJ;AAeI;EACI,mBAAA;AAbR;;AAiBA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cC7IU;ED8IV,kBAAA;EACA,qBAAA;AAdF;AAeE;EACE,iBAAA;AAbJ","sourcesContent":["@import '../../../../../../sass/variables';\n\n#tbl_remessas thead {\n    background-color: #000 !important;\n}\n\nh3 {\n    color: #666;\n    font-weight: 600;\n    font-size: 12pt;\n    border: solid 2px $azul-400;\n    padding: 7px 10px;\n    border-radius: 5px;\n    background-color: rgba(34, 183, 255, 0.1);\n    margin-top: 25px;\n    text-align: left;\n    display: inline-block;\n}\n\n.btn-registrar {\n    margin-top: 23px;\n}\n\nh3 .qtd-item-remessa {\n    color: #ffb07e;\n}\n\nh3 .alert-remessa-azul {\n    color: $azul-400;\n}\n\n.inicio {\n    margin: 20px;\n}\n\n@media only screen and (max-width: 1350px) {\n    #remessas {\n        h3 {\n            width: 100%;\n            text-align: center;\n        }\n    }\n\n    .pull-right {\n        width: 100%;\n        float: left !important;\n\n        .dropdown {\n            width: 57%;\n            float: left;\n            margin-left: 0;\n            margin-right: 1.5%;\n            margin-top: 7.5px;\n        }\n\n        .btn-registrar {\n            width: 40%;\n            float: left;\n            margin-left: 1.5%;\n            margin-top: 32px;\n        }\n    }\n}\n\n@media only screen and (max-width: 465px) {\n    #remessas {\n        h3 {\n            width: 100%;\n        }\n    }\n\n    .pull-right {\n        width: 100%;\n        float: left !important;\n\n        .dropdown {\n            width: 100%;\n            margin-left: 0;\n            margin-right: 0;\n            margin-top: 7.5px;\n        }\n\n        .btn-registrar {\n            width: 100%;\n            margin-top: 5px;\n            margin-left: 0;\n        }\n    }\n}\n\n.dropdown {\n    margin-left: 7.5px;\n    margin-right: 20px;\n    margin-bottom: 7.5px;\n    float: left;\n}\n\n.dropdown-toggle.btn-default {\n    transition: 0.5s;\n}\n\n.dropdown-toggle.btn-default:hover, .dropdown-toggle.btn-default:focus {\n    background-color: $white;\n    border: 1px solid $azul-200;\n    transition: 0.5s;\n}\n\n.dropdown.open > .btn {\n    box-shadow: none;\n}\n\n.dropdown label {\n    width: 100%;\n    line-height: 17px;\n}\n\n.dropdown button {\n    border-width: 1px;\n    width: 100%;\n    background-color: $white;\n    margin-right: 20px;\n    text-align: left;\n    padding-left: 13px;\n    font-size: 13px;\n}\n\n.dropdown-menu {\n    width: 100%;\n}\n\n.dropdown-menu:not(.head-list) > li > a {\n    padding: 10px 20px;\n    cursor: pointer;\n}\n\n.dropdown .dropdown-toggle {\n    position: relative;\n}\n\n.dropdown .dropdown-toggle span {\n    position: absolute;\n    right: 10px;\n    top: 15px;\n}\n\n.container-loading {\n    width: 35px;\n    height: 35px;\n    margin: 0 auto;\n\n    .loading {\n        margin: 100px 0 0 0;\n    }\n}\n\n.error {\n  width: 100%;\n  font-size: 16px;\n  font-weight: 100;\n  color: $cinza-500;\n  text-align: center;\n  display: inline-block;\n  &:first-child {\n    margin-top: 100px;\n  }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
